import { render } from "./App.vue?vue&type=template&id=051e1cb3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=051e1cb3&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__